import { Web3Provider } from '@ethersproject/providers';
import WalletConnectProvider from '@walletconnect/web3-provider';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { ToastContainer, toast } from 'react-toastify';
import Web3 from 'web3';
import { ABI } from '../../web3/Abi.js';
import { ADDRESS } from '../../web3/Address.js';
import { coinBaseEthereum } from '../../web3/coinbase-config.js';
import { proofFun } from '../../web3/merkle_root.js';
import { connector } from '../../web3/walletConnect.js';


//  Enable session (triggers QR Code modal)
window.Buffer = window.Buffer || require('buffer').Buffer;
export const CONNECT_METAMASK_LOADER = "CONNECT_METAMASK_LOADER";
export const connectMetamaskLoader = (bool) => ({
  type: 'CONNECT_METAMASK_LOADER',
  payload: bool,
});

export const providerWalletConnect = new WalletConnectProvider({
  infuraId: "a55fd1654e0e461aba3499f524b9509d",
});

const walletconnect = new WalletConnectConnector({
  rpcUrl: `https://mainnet.infura.io/v3/a55fd1654e0e461aba3499f524b9509d`,
  bridge: "https://bridge.walletconnect.org",
  qrcode: true
})


export const connectMetaMaskFunc = (handleClose) => {
  return async (dispatch) => {

    dispatch(connectMetamaskLoader(true))
    // dispatch(DisconnectMetaMask())
    if (!window.ethereum) {
      window.open("https://metamask.app.link/dapp/mint-sistersofsaturn.web.app/", "_blank"); //ethereum main net
      // window.open("https://metamask.app.link/dapp/sostestapp.web.app/", "_blank"); //ethereum main net
      // window.open("https://metamask.app.link/dapp/hydromintapp.web.app", "_blank"); //goerli test net
      return;
    }
    const metaProvider = await metaMaskProvider();
    // metaProvider
    //   .request({ method: "eth_accounts" })
    //   .then((data) => {
    metaProvider
      .request({
        method: "eth_requestAccounts",
      })
      .then((accounts) => {
        if (accounts[0].length) {
          localStorage.setItem("HydroTokenId", accounts[0])
          localStorage.setItem("connectionType", 'metamask')
          toast.success("Metamask have been connected")
          dispatch(getMetamaskUser())
          dispatch(totalSupply())

          dispatch(saleStatus())
          dispatch(balanceMetamaskUser())
          dispatch(getPrice(metaMaskProvider, 'metamask'))

          if (handleClose) {
            handleClose()
          }
        }
        dispatch(connectMetamaskLoader(false))
      })
      .catch(() => {
        dispatch(connectMetamaskLoader(false))
      });
    return;
    // })
  }
};

export const connnectMetamaskUser = (handleClose) => {
  return async (dispatch) => {
    dispatch(connectMetamaskLoader(true))
    try {
      if (!window?.ethereum?.isMetaMask) {
        window.open("https://metamask.app.link/dapp/mint-sistersofsaturn.web.app/", "_blank"); //main net
      // window.open("https://metamask.app.link/dapp/sostestapp.web.app/", "_blank"); //ethereum main net
      // window.open("https://metamask.app.link/dapp/hydromintapp.web.app", "_blank"); // goerli testnet
        return
      }
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      const account = accounts[0];
      localStorage.setItem("HydroTokenId", accounts[0])
      localStorage.setItem("connectionType", 'metamask')
      toast.success("MetaMask Wallet have been connected")
      dispatch(getMetamaskUser())
      dispatch(totalSupply())

      dispatch(saleStatus())
      dispatch(balanceMetamaskUser())
      dispatch(getPrice())

      if (handleClose) {
        handleClose()
      }
    } catch {
      handleClose()

      // toast.error("Please Try Again!")
    }
  };
};


export function connectCoinbaseWallet(handleClose) {
  return async (dispatch) => {
    dispatch(connectMetamaskLoader(true));
    // dispatch(DisconnectMetaMask())
    let accounts = false;
    // const web3 = new Web3(coinBaseEthereum);
    accounts = await new Promise((resolve, reject) => {
      coinBaseEthereum
        .request({ method: "eth_requestAccounts" })
        .then((response) => {
          accounts = response;
          resolve(accounts);
          dispatch(connectMetamaskLoader(false));
          localStorage.setItem("HydroTokenId", accounts[0])
          localStorage.setItem("connectionType", 'CoinBase')
          toast.success("CoinBase have been connected")
          dispatch(getMetamaskUser())
          dispatch(totalSupply())

          dispatch(saleStatus())
          dispatch(balanceMetamaskUser())
          dispatch(getPrice(coinBaseEthereum, 'CoinBase'))

          if (handleClose) {
            handleClose()
          }
        }).catch(() => {
          dispatch(connectMetamaskLoader(false));
          handleClose()
        });
    });
  };
}

export function connectWalletConnect(handleCancel) {
  return async (dispatch) => {
    //  Create WalletConnect Provider


    //  Enable session (triggers QR Code modal)
    await providerWalletConnect.enable();
    const web3 = new Web3(providerWalletConnect);
    const accounts = await web3.eth.getAccounts();
    console.log(accounts, 'waletconnect')

    // setTimeout(() => {
    // localStorage.setItem("subDomain", user.sub)
    // localStorage.setItem("HydroTokenId", user.wallet_address)
    let wcData = JSON.parse(localStorage.getItem('walletconnect'))
    if (wcData) {
      localStorage.setItem("HydroTokenId", accounts[0])
      localStorage.setItem("connectionType", "walletConnect")
    }
    handleCancel()
    dispatch(getMetamaskUser())
    dispatch(totalSupply(providerWalletConnect))

    dispatch(saleStatus())
    dispatch(getPrice(walletconnect, 'walletConnect'))


  }
}


// get matamask

export const BALANCE_METAMASK_LOADER = "BALANCE_METAMASK_LOADER";
export const balanceMetamaskLoader = (bool) => ({
  type: 'BALANCE_METAMASK_LOADER',
  payload: bool,
});


export const balanceMetamaskUser = () => {
  return async (dispatch) => {
    dispatch(balanceMetamaskLoader(true))
    let account = localStorage.getItem("HydroTokenId")
    try {
      const web3 = new Web3(await getCurrentProvider());
      let balance = 0
      web3.eth.getBalance(account).then((res) => {
        const etherValue = Web3.utils.fromWei(String(res), 'ether')
        dispatch(balanceMetamask(etherValue))
      });
      if (balance) {
        dispatch(balanceMetamaskLoader(false))
      }
    } catch {
      dispatch(balanceMetamaskLoader(false))
      toast.error("Please Try Again!")
    }
  };
};


export const BALANCE_METAMASK = "BALANCE_METAMASK";
export const balanceMetamask = (bool) => ({
  type: 'BALANCE_METAMASK',
  payload: bool,
});
export const SET_MINT_PRICE = "SET_MINT_PRICE";
export const setMintPrice = (price) => ({
  type: 'SET_MINT_PRICE',
  payload: price,
});


export const getMetamaskUser = () => {
  return async (dispatch) => {
    let HydroTokenId = localStorage.getItem("HydroTokenId")
    let connectionType = localStorage.getItem("connectionType")
    let username = localStorage.getItem("subDomain")

    dispatch(connectMetaMaskData({ HydroTokenId, connectionType, username }))
  };
};

//Set User Profile
export const GET_META_MASK_DATA = "GET_META_MASK_DATA";
export const connectMetaMaskData = (payload) => ({
  type: GET_META_MASK_DATA,
  payload: payload,
});

export const getCurrentProvider = async () => {
  let provider;
  if (window?.ethereum?.isMetaMask) {
    provider = window.ethereum;
  }
  if (window?.ethereum?.providers) {

    window?.ethereum?.providers?.forEach(async (p) => {
      if (p?.isMetaMask) {
        provider = p;
      }
    });
  }
  return provider;

};

export const metaMaskProvider = async () => {

  if (typeof window.ethereum !== "undefined") {
    let provider;
    if (window.ethereum.isMetaMask) {
      provider = window.ethereum;
    }
    if (window.ethereum.providers?.length) {
      window.ethereum.providers.forEach(async (p) => {
        if (p.isMetaMask) {
          provider = p;
        }
      });
    }
    return provider;
  }
};






export const DisconnectMetaMask = (redirect) => {
  return async (dispatch) => {
    let connectionType = localStorage.getItem("connectionType")
    localStorage.removeItem("HydroTokenId")
    localStorage.removeItem("connectionType")
    localStorage.removeItem('username')
    localStorage.removeItem('subDomain')
    localStorage.removeItem('connectionType')
    toast.success(`${connectionType} have been disconnected`)
    dispatch(getMetamaskUser())
    dispatch(totalSupply())

    dispatch(saleStatus())
    // redirect('/')

  };
}





export const switchNetwork = (window) => {
  return async (dispatch) => {
    let currentProvider = await getCurrentProvider(window);
    // let web3Provider = web3WithProvider(window)
    const web3 = new Web3(currentProvider);
    try {
      await currentProvider.request({
        method: "wallet_switchEthereumChain",
        // params: [{ chainId: web3.utils.toHex(5) }], //goerli test net
        params: [{ chainId: web3.utils.toHex(1) }], //eth main net
      });

    } catch (err) {
      toast.error('Please try again')
    }

  }
}

export const checkNetwork = (window) => {
  return async (dispatch) => {
    let currentProvider = await getCurrentProvider(window);
    // if (Number(currentProvider.networkVersion) !== 5) { //goerli test net
    if (Number(currentProvider.networkVersion) !== 1) {
      dispatch(switchNetwork(window))
    }

  }
}

export const getAuthUserWC = (handleCancel, dispatch, getLibrary) => {
  return async (dispatch) => {

    // setTimeout(() => {
    // localStorage.setItem("subDomain", user.sub)
    // localStorage.setItem("HydroTokenId", user.wallet_address)
    let wcData = JSON.parse(localStorage.getItem('walletconnect'))
    if (wcData) {
      localStorage.setItem("HydroTokenId", wcData.accounts[0])
      localStorage.setItem("connectionType", "walletConnect")
    }
    handleCancel()
    dispatch(getMetamaskUser())
    dispatch(totalSupply(getLibrary))

    dispatch(saleStatus())
    dispatch(getPrice(walletconnect, 'walletConnect'))


    // }, 1000)
  }
}



export const getPrice = (provider) => {
  return async (dispatch) => {
    let address = localStorage.getItem("HydroTokenId")
    let type = localStorage.getItem("connectionType")
    // if (address) {
    try {



      let web3;
      if (type === 'metamask') {
        web3 = new Web3(await metaMaskProvider());
      } else if (type === 'CoinBase') {
        web3 = new Web3(await coinBaseEthereum)
      } else if (type === 'walletConnect') {
        if (providerWalletConnect) {
          providerWalletConnect.enable();
          console.log(providerWalletConnect, 'providerWalletConnect')
          // console.log(getLibrary.provider,'getLibrary')
          // let provider = new Web3Provider(getLibrary)
          // const connectors = {
          //   // injected,
          //   walletconnect,
          //   // uauth
          // }
          // const connector = connectors['walletconnect']
          // // connector.walletConnectProvider
          web3 = new Web3(providerWalletConnect)
        }
      }
      // else if (type === 'walletConnect') {
      //       const connectors = {
      //         // injected,
      //         walletconnect,
      //         // uauth
      //       }
      //       const connector = connectors['walletconnect']
      //       // connector.walletConnectProvider
      //       web3 = new Web3(await walletconnect)
      //     }
      if (web3) {

        const hydro = new web3.eth.Contract(ABI, ADDRESS);


        const price = await hydro.methods.mintPrice().call()
        // const referalEarnings = agod.methods/
        if (price) {
          // return price
          dispatch(setMintPrice(price))
          // toast.success('You have succesfully purchased AGOD TOKEN')
        }
      }
    } catch (err) {
      if (err.message === `Returned values aren't valid, did it run Out of Gas? You might also see this error if you are not using the correct ABI for the contract you are retrieving data from, requesting data from a block number that does not exist, or querying a node which is not fully synced.`) {
        // toast.error('We are using Goerli Testnet for now, please switch you network to Goerli Testnet')
        toast.error('We are using Ethereum Main, please switch you network to Ethereum Main')
      } else {
        toast.error(err.message)
      }
      // toast.error('referalEarningsFn failed')

    }
  }
  // }
}

export const MINT_LOADER = "MINT_LOADER";
export const mintLoader = (bool) => ({
  type: 'MINT_LOADER',
  payload: bool,
});

export const mint = (addressUser, quantity, price) => {
  return async (dispatch) => {
    dispatch(mintLoader(true))
    let address = localStorage.getItem("HydroTokenId")
    let type = localStorage.getItem("connectionType")
    if (type === 'metamask') {
      const metaProvider = await metaMaskProvider();
      // metaProvider
      //   .request({ method: "eth_accounts" })
      //   .then((data) => {
      metaProvider
        .request({
          method: "eth_requestAccounts",
        })
    }
    // return
    // return
    if (address) {
      let proofFunValue = proofFun(address)
      // return
      if (proofFunValue[0]) {
        // if (true) {
        try {

          let web3;
          if (type === 'metamask') {
            web3 = new Web3(await metaMaskProvider());
          } else if (type === 'CoinBase') {
            web3 = new Web3(await coinBaseEthereum)
          } else if (type === 'walletConnect') {
            if (providerWalletConnect) {
              providerWalletConnect.enable();
              console.log(providerWalletConnect, 'providerWalletConnect')
              // console.log(getLibrary.provider,'getLibrary')
              // let provider = new Web3Provider(getLibrary)
              // const connectors = {
              //   // injected,
              //   walletconnect,
              //   // uauth
              // }
              // const connector = connectors['walletconnect']
              // // connector.walletConnectProvider
              web3 = new Web3(providerWalletConnect)
            }
          }
          //  else if (type === 'walletConnect') {
          //   const connectors = {
          //     // injected,
          //     walletconnect,
          //     // uauth
          //   }
          //   const connector = connectors['walletconnect']
          //   // connector.walletConnectProvider
          //   web3 = new Web3(await walletconnect)
          // }
          console.log(quantity, proofFunValue[1], 'quantity, proofFunValue[1]')
          if (web3) {
            const hydro = new web3.eth.Contract(ABI, ADDRESS);
            // const mintingToken = await hydro.methods.mintToken(quantity, proofFunValue[1]).send({ from: address, value: price })
            // For testing your userAddress = 0x71bda3604af7805Eaa240A8f2909cA1dDB83bC95  
            const mintingToken = await hydro.methods.mintToken(quantity, proofFunValue[1]).send({ from: address, value: Number(price) * Number(quantity) })

            // const mintingToken = agod.methods/ 
            if (mintingToken) {
              toast.success('You have succesfully minted')
              dispatch(mintLoader(false))
              dispatch(totalSupply())

            }
          }
        } catch (err) {
          dispatch(mintLoader(false))
          toast.error(err.message)
          // toast.error('mintingTokenFn failed')

        }
      } else {
        dispatch(mintLoader(false))
        toast.error("User is not White Listed")

      }
    }
  }
}



export const saleStatus = () => {
  return async (dispatch) => {
    let address = localStorage.getItem("HydroTokenId")
    let type = localStorage.getItem("connectionType")
    let web3;
    if (type === 'metamask') {
      web3 = new Web3(await metaMaskProvider());
    } else if (type === 'CoinBase') {
      web3 = new Web3(await coinBaseEthereum)
    } else if (type === 'walletConnect') {
      if (providerWalletConnect) {
        providerWalletConnect.enable();
        console.log(providerWalletConnect, 'providerWalletConnect')
        // console.log(getLibrary.provider,'getLibrary')
        // let provider = new Web3Provider(getLibrary)
        // const connectors = {
        //   // injected,
        //   walletconnect,
        //   // uauth
        // }
        // const connector = connectors['walletconnect']
        // // connector.walletConnectProvider
        web3 = new Web3(providerWalletConnect)
      }
    }
    // else if (type === 'walletConnect') {
    //         const connectors = {
    //           // injected,
    //           walletconnect,
    //           // uauth
    //         }
    //         const connector = connectors['walletconnect']
    //         // connector.walletConnectProvider
    //         web3 = new Web3(await walletconnect)
    //       }
    const hydro = new web3.eth.Contract(ABI, ADDRESS);
    const earlySale = await hydro.methods.earlySale().call()
    const publicSale = await hydro.methods.publicSale().call()
    const preSale = await hydro.methods.preSale().call()

    dispatch(saleStatusData(earlySale,
      publicSale,
      preSale))
  }
  // }
}
export const SALE_STATUS = "SALE_STATUS";
export const saleStatusData = (earlySale,
  publicSale,
  preSale) => ({
    type: 'SALE_STATUS',
    payload: {
      earlySale,
      publicSale,
      preSale
    },
  });

export const totalSupply = () => {
  return async (dispatch) => {
    let address = localStorage.getItem("HydroTokenId")
    let type = localStorage.getItem("connectionType")
    let web3;
    if (type === 'metamask') {
      web3 = new Web3(await metaMaskProvider());
    } else if (type === 'CoinBase') {
      web3 = new Web3(await coinBaseEthereum)
    } else if (type === 'walletConnect') {
      if (providerWalletConnect) {
        providerWalletConnect.enable();
        console.log(providerWalletConnect, 'providerWalletConnect')
        // console.log(getLibrary.provider,'getLibrary')
        // let provider = new Web3Provider(getLibrary)
        // const connectors = {
        //   // injected,
        //   walletconnect,
        //   // uauth
        // }
        // const connector = connectors['walletconnect']
        // // connector.walletConnectProvider
        web3 = new Web3(providerWalletConnect)
      }
    }
    console.log(web3, 'web3')
    const hydro = new web3.eth.Contract(ABI, ADDRESS);
    const totalSupply = await hydro.methods.totalSupply().call()
    const minted = await hydro.methods.minted().call()
    const tokensLeft = await hydro.methods.tokensLeft().call()
    const balanceOf = await hydro.methods.balanceOf(address).call()
    dispatch(totalSupplyData(totalSupply, minted, tokensLeft, balanceOf))
  }
  // }
}
export const TOTAL_SUPPLY = "TOTAL_SUPPLY";
export const totalSupplyData = (totalSupply, minted, tokensLeft, balanceOf) => ({
  type: 'TOTAL_SUPPLY',
  payload: { totalSupply, minted, tokensLeft, balanceOf },
});